import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import { observer } from "mobx-react-lite";
import React from "react";
import IconButton3D from "./IconButton3D";
import { useStore } from "csi/state/hooks";

const Reset = observer(() => {
	const rootStore = useStore();
	const { threeDStore: { resetViewer } } = rootStore;
    
	return (
		<IconButton3D
			fontSize={19}
			onClick = {resetViewer}
			res="3DViewZoomReset"
		>
			<SettingsBackupRestoreIcon />
		</IconButton3D>
	);
});

export default Reset;